<script lang="ts">
    import {Button, Heading, Label, Modal, Progressbar, Select} from "flowbite-svelte";
    import {CirclePlusSolid, ExclamationCircleSolid} from "flowbite-svelte-icons";
    import FileDrop from "$lib/components/FileDrop.svelte";
    import {globalToast} from "$lib/stores/toast";
    import Sleep from "$lib/utils/sleep";
    import {formDataPost} from "$lib/api";
    import {currentCustomer} from "$lib/stores/customer";
    import {storageDocuments} from "$lib/stores/documents";

    export let category: {title: string, categories: [{name: string, filter: string[]}]}

    let uploadModal = false

    let uploadList: {file: File, tags: string[] | string, progress: number}[] = []
    const photoLoader = (accepted, rejected) => {
        console.log({accepted, rejected})
        accepted.forEach((file) => {
            uploadList = [
                ...uploadList,
                {file, tags: category.categories.length === 1 ? category.categories[0].filter : [], progress: 0}
            ]
        })
    }
    const upload = async() => {
        let error = false;
        for(let i = 0; i < uploadList.length; i++) {
            uploadList[i].progress = 25
            try{
                const res = await formDataPost('/storage-document', {
                    ...uploadList[i],
                    customerUuid: $currentCustomer.uuid
                })
                $storageDocuments = [...$storageDocuments.filter(x => x.id !== res.id), res]

            } catch (e) {
                $globalToast.timed('Upload fehlgeschlagen', 1000, ExclamationCircleSolid)
                await Sleep(800)
                error = true;
            }
            uploadList[i].progress = 100

            await Sleep(500)
        }
        if(!error) {
            uploadList = []
            uploadModal = false
        }

    }
</script>
<div class="h-full flex flex-col">
    <Heading tag="h5" class="text-neutral-600 mb-3"><span class="text-primary-600">{category.title}</span></Heading>
    <div class="flex flex-col gap-3 flex-1">
        <Button size="sm" outline pill on:click={() => uploadModal = true}>
            <CirclePlusSolid class="pr-1"/>
            Dokument
        </Button>
    </div>
</div>
<Modal title="Upload" bind:open={uploadModal} size="xl">
    <FileDrop extract={photoLoader} allowedFiles={['jpg', 'jpeg', 'png', 'pdf', 'gif', 'doc', 'docx', 'dotx', 'ppt', 'pptx', 'xls', 'xlsx']} allowedSize="6MB"/>
    <form on:submit|preventDefault={upload}>
        <div class="grid grid-cols-2 gap-3">
            {#each uploadList as uploadObject}
                <div class="border rounded p-3">
                    <div class="flex justify-end">
                        <Button color="red" size="xs" on:click={() => uploadList = uploadList.filter((u) => u !== uploadObject)}>X</Button>
                    </div>
                    <div>
                        {uploadObject.file.name}
                    </div>
                    <Label class="space-y-2 mb-2">
                        <span>Katalogisierung</span>
                        <Select bind:value={uploadObject.tags} required>
                            {#each category.categories.filter((x) => x.name !== 'contract') as tagedCategorie}
                                <option value={tagedCategorie.filter}>{tagedCategorie.filter.join(', ')}</option>
                            {/each}
                        </Select>
                    </Label>
                    <Progressbar progress="{uploadObject.progress}" color="green"/>
                </div>


            {/each}
        </div>
        <div class="mt-3">
            <Button type="submit">Upload</Button>
        </div>
    </form>


</Modal>